import React, { useContext } from 'react';
import {
  bool, string
} from 'prop-types';
import { ExperienceContext, useStore } from '@thd-nucleus/experience-context';
import {
  StorePod,
  StorePodName,
  StorePodLink,
  StorePodLocalize,
  StorePodRating
} from '@thd-olt-component-react/store-pod';
import { Link } from '@one-thd/sui-atomic-components';
import { StoreHeroContext } from '../../StoreHero.context';

const StoreHeroHeader = ({
  hideActionButton,
  hideRating,
  label
}) => {
  const { loading, store } = useContext(StoreHeroContext);
  const { storeId } = store || {};
  const { storeId: localizedStoreId } = useStore();
  const { channel } = useContext(ExperienceContext);
  const isMobile = channel === 'mobile';

  const triggerLocDrawer = () => {
    document.dispatchEvent(new CustomEvent('launchLocDrawer'));
  };

  const isLocalizedStore = storeId?.replace(/^0+/, '') === localizedStoreId?.replace(/^0+/, '');

  return (
    <div data-component="StoreHeroHeader">
      <StorePod loading={loading} store={store}>
        <div className="sui-mb-2">
          <div className="sui-flex sui-flex-col sm:sui-flex-row md:sui-gap-4 md:sui-items-end">
            <StorePodName
              label={label}
              variant="h1"
            />
            {!isMobile && (
              <Link href="#/" align="left" component="button" onClick={triggerLocDrawer}>
                Change Store
              </Link>
            )}

          </div>
          {!hideRating && (
            <StorePodRating />
          )}
          <div className="sui-mt-2 sui-grid md:sui-grid-cols-6 sui-grid-cols-2 ">
            {isLocalizedStore && !hideActionButton && (
              <StorePodLink type="localAd" visualStyle="button" />
            )}
            {!isLocalizedStore && !hideActionButton && (
              <StorePodLocalize color="orange" />
            )}
          </div>
        </div>
      </StorePod>
    </div>
  );
};

StoreHeroHeader.displayName = 'StoreHeroHeader';

StoreHeroHeader.propTypes = {
  hideActionButton: bool,
  hideRating: bool,
  label: string,
};

StoreHeroHeader.defaultProps = {
  hideActionButton: false,
  hideRating: false,
  label: ''
};

export { StoreHeroHeader };
